<template>
  <div>
    <div class="container pt-0">
      <div class="row" :class="{ blurred: $store.state.loading }">
        <div class="col-md-8 mb-4 mb-md-0">
          <div class="pane text-center">
            <h1>{{ $t("heading_booking") }}</h1>
            <a
              v-if="otp_url"
              class="dark-btn pl-5 pr-5 mt-4 d-inline-block"
              :href="otp_url"
            >
              {{ $t("btn_book") }}
            </a>
            <button
              v-else
              class="dark-btn pl-5 pr-5 mt-4"
              @click="$store.commit('setPage', 'otp')"
            >
              {{ $t("btn_book") }}
            </button>
          </div>
        </div>
        <div class="col-md-4 cursor text-center">
          <div
            class="pane pane-inverted emergency-hover"
            @click="$store.commit('setPage', 'notfall')"
          >
            <div class="h1-like">{{ $t("heading_emergency") }}</div>
            <br />
            <div class="row">
              <div class="col-md-12 col-lg-7 pl-lg-0">
                <div class="h2-like">
                  <font-awesome-icon icon="phone" /><br />{{
                    $t("telefon_notfall")
                  }}
                </div>
              </div>
              <div class="col-12 d-md-none">
                <hr />
              </div>
              <div class="col-md-12 col-lg-5">
                <div class="h2-like">
                  <font-awesome-icon icon="envelope" /><br />E-Mail
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="$store.state.loading"
        class="position-absolute top-50 start-50 translate-middle"
      >
        <font-awesome-icon icon="spinner" spin size="2x" />
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
//import Start from "@/components/Start.vue";

export default {
  name: "StartseiteComponent",
  components: {
    //Start,
  },
  computed: {
    otp_url() {
      return navigator.bx_otp_url;
    },
  },
};
</script>
